import React from "react"
import {Button} from "semantic-ui-react"
import PropTypes from "prop-types"
import { trackRemoveFromCart } from "components/tracking/Tracking";

export default function ProductRowCartAction  ( { cart, product } )  {
	return (
		<Button className="productRowCartAction"
			onClick={() => {
				cart.remove( product )
				trackRemoveFromCart(product.map_id, product.title)
			}}
			style={{border: "none", background: "none"}}
			icon="trash alternate"
			size="big"
		/>
	)
}

ProductRowCartAction.propTypes = {
	cart:    PropTypes.object,
	product: PropTypes.object,
}





// WEBPACK FOOTER //
// ./src/theme/demo2025/components/Product/ProductRowCartAction.js